import {
  IberiaCardsCampaign,
  IberiaCardsCampaignGroup,
} from '@/components/modules/Application/IberiaCards/_shared/types/IberiaCardsCampaign';

export const IBERIA_CARDS_CAMPAIGNS: IberiaCardsCampaign[] = [
  {
    id: 'icon-generica',
    campaign: 'PII25091',
    product: 'Icon',
    avios: 20000,
    customerType: 1,
    cardProduct: 4511,
    cardBrand: 4,
    cardType: 45,
    description: 'CAMPAÑA ICON GENÉRICA',
    group: IberiaCardsCampaignGroup.INDIVIDUALS,
  },
  {
    id: 'aire-generica',
    campaign: 'PAI25101',
    product: 'Aire',
    avios: 15500,
    customerType: 1,
    cardProduct: 7231,
    cardBrand: 4,
    cardType: 72,
    description: 'CAMPAÑA AIRE GENÉRICA',
    group: IberiaCardsCampaignGroup.INDIVIDUALS,
  },
  {
    id: 'icon-empleados-iberia',
    campaign: 'PEI26011',
    product: 'Icon',
    avios: 20000,
    customerType: 2,
    cardProduct: 4521,
    cardBrand: 4,
    cardType: 45,
    description: 'EMPLEADOS IBERIA',
    group: IberiaCardsCampaignGroup.IBERIA_EMPLOYEES,
  },
  {
    id: 'zenit-cliente-existente',
    campaign: 'PZI25101',
    product: 'Zenit',
    avios: 10000,
    customerType: 1,
    cardProduct: 7131,
    cardBrand: 4,
    cardType: 71,
    description: 'CAMPAÑA ZENIT CLIENTE EXISTENTE',
    group: IberiaCardsCampaignGroup.INDIVIDUALS,
    comment: 'Aquí entiendo que le saltará un aviso al agente',
  },
  {
    id: 'zenit-generica',
    campaign: 'PZI25103',
    product: 'Zenit',
    avios: 40000,
    customerType: 1,
    cardProduct: 7131,
    cardBrand: 4,
    cardType: 71,
    description: 'CAMPAÑA ZENIT GENÉRICA',
    group: IberiaCardsCampaignGroup.INDIVIDUALS,
  },
  {
    id: 'icon-tpe-aiace',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4513,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 300000062,
    description: 'AIACE',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-helios-healthcare',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4531,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 300000061,
    description: 'HELIOS HEALTHCARE',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-statkraft-develop',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4613,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 300000050,
    description: 'STATKRAFT DEVELOP',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-amadeus-it-group',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4631,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 500000043,
    description: 'AMADEUS IT GROUP',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-club-del-deportista',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4513,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 300000058,
    description: 'CLUB DEL DEPORTISTA',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-atresmedia-corpora',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4531,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 500000048,
    description: 'ATRESMEDIA CORPORA',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-management-solutio',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4531,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 500000023,
    description: 'MANAGEMENT SOLUTIO',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-outpayce',
    campaign: 'PIB18041',
    product: 'Icon TPE',
    avios: 9000,
    customerType: 1,
    cardProduct: 4631,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 500000054,
    description: 'OUTPAYCE',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-airbus',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4531,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 500000012,
    description: 'AIRBUS',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-icam',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4544,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1200000066,
    description: 'ICAM',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-lg',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4544,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1200000067,
    description: 'LG',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-sepla',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4546,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1300000064,
    description: 'SEPLA',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-oliver-wyman',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4548,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1400000070,
    description: 'OLIVER WYMAN',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-deloitte-auditores',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4548,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1400000068,
    description: 'DELOITTE AUDITORES',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'aire-icam-ilunion-y-deloitte',
    campaign: 'PAI25101',
    product: 'Aire',
    avios: 15500,
    customerType: 23,
    cardProduct: 7231,
    cardBrand: 4,
    cardType: 72,
    corporateGroup: 0,
    description: 'ICAM,ILUNION Y DELOITTE',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'zenit-deloitte-60000',
    campaign: 'PZI26073',
    product: 'Zenit',
    avios: 60000,
    customerType: 1,
    cardProduct: 7131,
    cardBrand: 4,
    cardType: 71,
    corporateGroup: 0,
    description: 'DELOITTE',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'zenit-deloitte-30000',
    campaign: 'PZI26071',
    product: 'Zenit',
    avios: 30000,
    customerType: 1,
    cardProduct: 7131,
    cardBrand: 4,
    cardType: 71,
    corporateGroup: 0,
    description: 'DELOITTE',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
    comment: 'Aquí entiendo que le saltará un aviso al agente',
  },
  {
    id: 'icon-tpe-amazon',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4544,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1300000072,
    description: 'AMAZON',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-womenalia',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4544,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1200000076,
    description: 'WOMENALIA',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
  {
    id: 'icon-tpe-tsk',
    campaign: 'PII25091',
    product: 'Icon TPE',
    avios: 20000,
    customerType: 1,
    cardProduct: 4544,
    cardBrand: 4,
    cardType: 45,
    corporateGroup: 1200000077,
    description: 'TSK',
    group: IberiaCardsCampaignGroup.CORPORATE_GROUPS,
  },
];
